/** The public PDF address of a document link: `<rootUrl>/api/document-link/<token>/pdf`. `rootUrl` is empty for a same-origin address. */
export const buildDocumentLinkPdfUrl = ({ rootUrl = '', token }: { rootUrl?: string; token: string }): string =>
  `${rootUrl}/api/document-link/${encodeURIComponent(token)}/pdf`
